import React,{ useEffect, useState,forwardRef, useImperativeHandle } from "react"
import { Button, Table } from "react-bootstrap";
import i18n from "../../../../i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import cookieManager from "../../../../utils/cookieManager";
import Select2 from '../../../utilities/Form/Select2';
import InputNumber from "../../../utilities/Form/InputNumber";

const token=cookieManager.getUserToken();

const getLedger=()=>{
    return axios.get(process.env.REST_URL+'helper/get-ledger-cost',{
        headers:{
            Authorization:'Bearer '+ token
        },
        responseType: "json",
    })
}


const FormDiff=forwardRef((props, ref)=>{
    const [data,setData]=useState([]);
    const [listLedger,setLedger]=useState([])
    
    useEffect(()=>{
        getLedger().then((response)=>{
            setLedger(response.data.result) 
        })
    },[])
    useImperativeHandle(ref, () => ({
        addDetail:(cost)=>{
            const checkIndex = data.findIndex(item => item.idDetail === cost.idDetail);
            let value;

            if (checkIndex !== -1) {
                value = [...data];
                value[checkIndex] = {
                ...value[checkIndex],
                nominal: cost.nominal,
                remark: cost.remark,
                };
            }else{
                value=[...data,{
                    remark:cost.remark,
                    nominal:cost.nominal,
                    ledgerCurrent:null,
                    removeable:0,
                    idDetail:cost.idDetail,
                    idItem:cost.idItem
                } ]
            }
            
            setData(value)
        },
        removeDetail:(idDetail)=>{
            const newData = data.filter((value, index) => value.idDetail !== idDetail);
            setData(newData)
        },
        resetDetail:()=>{
            setData([])
        },
        postData:()=>{
            return data
        }
      }));


    return(
        <Table bordered striped hover className="table-diff-bordered">
            <thead>
                <tr>
                   <th rowSpan={2} className="align-middle">No</th> 
                   <th colSpan={3}>Biaya</th>
                   <th rowSpan={2} className="align-middle">Action</th> 
                </tr>
                <tr>
                    <th >Keterangan</th> 
                    <th >Buku Besar</th> 
                    <th >Nominal</th> 
                </tr>
            </thead>
            <tbody>
                {
                    data.map((row,i)=>
                    <tr key={'biayarow'+i}>
                        <td align="center" className="align-middle">{i+1}</td>
                        <td ><textarea
                            rows={1}
                            value={row.remark}
                            disabled={row.removeable?false:true}
                            className="form-control form-control-sm"
                            onChange={(e)=>{
                                const newData = [...data];
                                newData[i] = { ...newData[i], remark: e.target.value };
                                setData(newData);
                            }}
                            >
                            </textarea>
                            </td>
                        <td className="align-middle">
                            <Select2 
                                isClearable={true}
                                name={'LedgerCost'}
                                required={true}
                                className={""}
                                size={4}
                                
                                onChange={async (e)=>{
                                    const newData = [...data];
                                    newData[i] = { ...newData[i], ledgerCurrent: e };
                                    setData(newData);
                                    }
                                }
                                options={listLedger}
                                title={'Choose Ledger'}
                                value={row.ledgerCurrent}
                                placeholder={'Choose Ledger'}
                                labelfield={'false'}
                            />
                        </td>
                        <td className="align-middle">{
                                <InputNumber
                                id={"nominal"+i}
                                name="nominal"
                                disabled={row.removeable?false:true}
                                placeholder={i18n.t("Nominal")}
                                defaultValue={0}
                                value={row.nominal}
                                decimalsLimit={2}
                                onValueChange={async (value)=>{
                                    const newData = [...data];
                                    newData[i] = { ...newData[i], nominal: value };
                                    setData(newData);
                                }}
                                className='form-control  form-control-sm text-end'
                                prefix='Rp '
                                labelfield={"false"}
                                // error={renderError('InvoiceBiaya.nominal.'+i)}
                                error={''}
                            />
                            }</td>
                        <td className="align-middle">{(row.removeable)?<Button variant="danger" size="sm" onClick={()=>{
                            const newData = data.filter((_, index) => index !== i);
                            setData(newData)
                        }}><FontAwesomeIcon icon={faMinus} className="p-0"></FontAwesomeIcon></Button>:null}</td>
                    </tr>
                    )
                }
            </tbody>
            <tfoot>
                <Button variant="success" className="my-5" onClick={()=>{
                    const value=[...data,{
                        remark:'',
                        nominal:0,
                        ledgerCurrent:null,
                        removeable:1,
                        idDetail:null
                    } ]

                    setData(value)
                }}  ><FontAwesomeIcon icon={faPlus} className="p-0"></FontAwesomeIcon> {i18n.t('Add')}</Button>
            </tfoot>
        </Table>
    )
})

export default FormDiff